__webpack_require__.p = "https://salesmanual.tissot.ch/";